// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2ZbHi","name":"ConsentHeader_name__2BzDf","birthday":"ConsentHeader_birthday__3kKB9","skeleton":"ConsentHeader_skeleton__lDfjL"};